import * as type from "./type";

export const getSupportDetailsListRequest = (data) => {
    return {
        type: type.GET_SUPPORT_DETAILS_LIST_REQUEST,
        payload: data
    };
};
export const getSupportDetailsListSuccess = (data) => {
    return {
        type: type.GET_SUPPORT_DETAILS_LIST_SUCCESS,
        payload: data
    };
};

export const addSupportDetailsRequest = (data) => {
    return {
        type: type.ADD_SUPPORT_DETAILS_REQUEST,
        payload: data
    };
};
export const addSupportDetailsSuccess = (data) => {
    return {
        type: type.ADD_SUPPORT_DETAILS_SUCCESS,
        payload: data
    };
};
export const deleteSupportDetailsRequest = (data) => {
    return {
        type: type.DELETE_SUPPORT_DETAILS_REQUEST,
        payload: data
    };
};
export const deleteSupportDetailsSuccess = (data) => {
    return {
        type: type.DELETE_SUPPORT_DETAILS_SUCCESS,
        payload: data
    };
};